import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from "@mui/material";
import { forwardRef } from "react";
export const UiButtonBase = forwardRef((props, ref) => _jsx(ButtonBase, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_button_base.js.map